import type { PersonInvolvement } from "../types/involvement.js";
import { isInvolvementLive } from "./isInvolvementLive.js";

/**
 * The involvement whose holder's work a newly started approver approves.
 */
export const liveDesignatedAssessorInvolvement = <
  R extends Pick<PersonInvolvement, "kind" | "endedAt" | "expiresAt">,
>(
  involvements: readonly R[],
  now: Date = new Date(),
): R | undefined =>
  involvements.find(
    (involvement) =>
      involvement.kind === "designated_assessor" &&
      isInvolvementLive(involvement, now),
  );
